<script>
  import { _ } from "./i18n.js";
  import { Page, Navbar, NavRight } from "framework7-svelte";
  import OrderAll from "./OrderAll.svelte";
  import { getSecuredFirestore } from "./Firestore.js";
  import { checkImage } from "./Utils.js";

  export let f7router;
  export let f7route;

  let userId = f7route.params.id;
  let name = f7route.params.name || userId;

  function getProfilePhoto(userId) {
    return getSecuredFirestore().then(function(firestore) {
      return firestore
        .collection("users")
        .doc(userId)
        .get()
        .then(function(snapshot) {
          let profilePhoto = snapshot.get("profilePhoto");
          if (profilePhoto) {
            return checkImage(profilePhoto).then(function(result) {
              return result ? profilePhoto : null;
            });
          } else {
            return null;
          }
        });
    });
  }
</script>

<Page>
  <Navbar
    title={$_('orderAll.title', { values: { name: name } })}
    backLink={$_('base.back')}>
    {#if userId}
      <NavRight>
        {#await getProfilePhoto(userId) then profilePhoto}
          {#if profilePhoto}
            <img
              style="max-width: 40px; border-radius: 50%; margin-right: 10px"
              alt="User Profile"
              src={profilePhoto} />
          {/if}
        {/await}
      </NavRight>
    {/if}
  </Navbar>
  <OrderAll {f7router} {f7route} />
</Page>
